import React from "react";
import {
    Modal,
    Button,
    ConfigProvider
} from 'antd'
import { useNavigate } from "react-router-dom";
import { clearStorage } from "../utils";
import { useDispatch, useSelector } from 'react-redux'
import { setIsFindModule } from '../redux/features/main/virtualAssistSlice'
import { useTranslation } from "react-i18next";

// color config
import { textTitleHome, checkCircleIcon } from '../config/constant/color/index'

const ModalNoModuleFound = () => {
  const { t, i18n } = useTranslation();
    const isFindModule = useSelector((state) => state.virtualAssist.isFindModule);
    const dispatch = useDispatch()
    var navigate = useNavigate();

    const onClickBtnPopup = () => {
        dispatch(setIsFindModule(false))
        navigate("/home");
    }
    return(
        <ConfigProvider
            theme={{
                components:{
                    Modal: {
                        borderRadiusLG: '24px'
                    }
                },
                token:{
                    fontFamily: 'Roboto'
                }
            }}
        >
            <Modal 
                open={isFindModule}
                maskClosable="false"
                closeIcon={false}
                width={420}
                centered
                footer={null}>
                <div style={{textAlign:'center', padding:'32px'}}>
                    <p style={{color:textTitleHome}}>
                        {t("main.popup.not_enrolled")}
                    </p>
                    <Button 
                        className="btn btn-sm btn-primary btn-block" 
                        style={{ borderRadius: '6px', border: 'none', fontWeight:'500', marginTop: '30px', height:'48px' }}
                        name="btn-ok-invalid"
                        onClick={() => onClickBtnPopup()}>
                            {t("main.popup.button_close")}
                    </Button>
                </div>
            </Modal>
        </ConfigProvider>
    )
}

export default ModalNoModuleFound